import React from 'react'
import { useSelector , useDispatch } from 'react-redux';
import { addToCart , deleteFromCart , addToWish , deleteFromWish , addCount , removeCount , addCountWish , removeCountWish } from '../redux';
import { Link } from 'react-router-dom';
import '../Basket.css';

function Wishlist() {
    const countReducerWish = useSelector(count => count.countReducerWish);
    useSelector(count => count.countReducerCart);
    const basketReducerWish = useSelector(state => state.basketReducerWish);
    useSelector(state => state.basketReducerCart);

    const dispatch = useDispatch();

    const toggleCart = (data) => {
        if (data.cartstate === false){
            data.cartstate = true;
            data.carted_text = "Remove from basket";
            data.carted_style = "carted_red_bg";
            dispatch(addCount(data.price));
            dispatch(addToCart(data));
        } else {
            data.cartstate = false;
            data.carted_text = "Add to basket";
            data.carted_style = "";
            dispatch(removeCount(data.price));
            dispatch(deleteFromCart(data));
        }
    }

    const toggleWish = (data) => {
        if (data.wishstate === false){
            data.wishstate = true;
            data.liked = "like-clicked";
            dispatch(addCountWish(1));
            dispatch(addToWish(data));
        } else {
            data.wishstate = false;
            data.liked = "";
            dispatch(removeCountWish(1));
            dispatch(deleteFromWish(data));
        }
    }

    return (
        <div>
            <div className="dflex jc-center">
                <div className="w74">
                    {
                    basketReducerWish.map(
                        (index,key) => 
                        <div key={key} className="basket-element-container">
                            <div className="basket-element-left">
                                    <div className="basket-element-image-zone">
                                        <Link key={key} to={`/all_instruments/${index.id}`}><img className="basket-image" src={index.img} alt="" /></Link>
                                        <div onClick={(event) => toggleWish(index)} className={`like ${index.liked}`}></div>
                                        {index.newOrNot === "New" ?<div className="basket-new"><p>New</p></div> : false}
                                    </div>
                                </div>
                                <div className="basket-element-text-zone">
                                    <div className="basket-element-text-zone-centering">
                                        <h1 className="">{index.marka}&nbsp;</h1>
                                        <h2 className="">{index.model}&nbsp;</h2>
                                        <h4 className="">{index.description}&nbsp;</h4>
                                        <h3 className="">${index.price}</h3>
                                        <button  onClick={(event) => toggleCart(index)} className={`basket-add-to-card ${index.carted_style}`}>{index.carted_text}</button>
                                    </div>
                                </div>
                        </div>
                    )
                    }
                    {countReducerWish < 0.05? 
                    <div className="basket-empty dflex jc-center ai-center">
                        <p>
                            You have no items
                            <br/>
                            in your <span>wishlist</span>
                        </p>
                    </div>
                    :
                    <div className="count-container">
                        <p>
                                Overall : {countReducerWish} {countReducerWish >1 ? "items" : "item"} in your wishlist
                        </p>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
};

export default Wishlist;